import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Route, Switch } from 'react-router-dom';
import Loading from '../view/MainBoard/Components/Loading';

//#region Route import
const Report = React.lazy(() => import(/* webpackChunkName: "Report"*/"../view/MainBoard/Report"));
const ForeignSuccess = React.lazy(() => import(/* webpackChunkName: "ForeignerSuccess"*/"../view/MainBoard/Foreigner/ForeignerSuccess"));
const ForeignPreview = React.lazy(() => import(/* webpackChunkName: "ForeignerPreview"*/"../view/MainBoard/Foreigner/ForeignerPreview"));
const ForeignBoard = React.lazy(() => import(/* webpackChunkName: "ForeignerBoard"*/"../view/MainBoard/Foreigner/ForeignerBoard"));
const Preview = React.lazy(() => import(/* webpackChunkName: "Preview"*/ '../view/MainBoard/zApplication/Preview'));
const Details = React.lazy(() => import(/* webpackChunkName: "Details"*/'../view/MainBoard/zApplication/Details'));
const Dashboard = React.lazy(() => import(/* webpackChunkName: "Dashboard"*/"../view/MainBoard/Dashboard"));
const Setting = React.lazy(() => import(/* webpackChunkName: "Setting"*/"../view/MainBoard/Setting"));
const Success = React.lazy(() => import(/* webpackChunkName: "Success"*/"../view/MainBoard/Success"));
const pageError = React.lazy(() => import(/* webpackChunkName: "pageError"*/"../view/404"));
const DonorRequest = React.lazy(() => import(/* webpackChunkName: "DonorRequest"*/"../view/MainBoard/DonorRequests"));
const Main = React.lazy(() => import(/* webpackChunkName: "Main"*/"../view/Main"));
const Faq = React.lazy(() => import(/* webpackChunkName: "Faq"*/"../view/FAQ"));
const LoginAuthentication = React.lazy(() => import(/* webpackChunkName: "LoginAuthentication"*/"../view/loginAuthentication"));
const SingpassLogin = React.lazy(() => import(/* webpackChunkName: "SingpassLogin"*/"../view/SingPassLogin"));
const PublicLogin = React.lazy(() => import(/* webpackChunkName: "PublicLogin"*/"../view/PublicLogin"));
const PublisherSubUser = React.lazy(() => import(/* webpackChunkName: "PublisherSubUser"*/"../view/RegisterForms/PublisherSubUser"));
const Registration = React.lazy(() => import(/* webpackChunkName: "Registration"*/"../view/RegisterForms/Registration"));
const RetroAccount = React.lazy(() => import(/* webpackChunkName: "RetroAccount"*/"../view/RegisterForms/RetroAccount"));
const CIPDetails = React.lazy(() => import(/* webpackChunkName: "CIPDetails"*/"../view/MainBoard/CIPApplication/Details"));
const CIPApplication = React.lazy(() => import(/* webpackChunkName: "CIPApplication"*/"../view/MainBoard/CIPApplication/ISNApplication"));
const CIPRequest = React.lazy(() => import(/* webpackChunkName: "CIPRequest"*/"../view/MainBoard/CIPApplication/Request"));
const CIPPreview = React.lazy(() => import(/* webpackChunkName: "CIPPreview"*/"../view/MainBoard/CIPApplication/Preview"));
const CIPSuccess = React.lazy(() => import(/* webpackChunkName: "CIPSuccess"*/"../view/MainBoard/CIPApplication/Success"));
const DepositDetails = React.lazy(() => import(/* webpackChunkName: "DepositDetails"*/"../view/MainBoard/DepositApplication/Details"));
const DepositSuccess = React.lazy(() => import(/* webpackChunkName: "DepositSuccess"*/"../view/MainBoard/DepositApplication/Success"));
const DepositApplication = React.lazy(() => import(/* webpackChunkName: "DepositApplication"*/"../view/MainBoard/DepositApplication/ISNApplication"));
const DepositRequest = React.lazy(() => import(/* webpackChunkName: "DepositRequest"*/"../view/MainBoard/DepositApplication/Request"));
const DepositPreview = React.lazy(() => import(/* webpackChunkName: "DepositPreview"*/"../view/MainBoard/DepositApplication/Preview"));
const DepositBlockPreview = React.lazy(() => import(/* webpackChunkName: "DepositBlockPreview"*/"../view/MainBoard/DepositApplication/BlockPreview"));
const DepositFileUpload = React.lazy(() => import(/* webpackChunkName: "DepositFileUpload"*/"../view/MainBoard/DepositApplication/FileUpload"));
const ISNApplicationDetails = React.lazy(() => import(/* webpackChunkName: "ISNApplicationDetails"*/"../view/MainBoard/ISNApplication/Details"));
const ISNApplicationEdit = React.lazy(() => import(/* webpackChunkName: "ISNApplicationEdit"*/"../view/MainBoard/ISNApplication/Edit"));
const ISNApplication = React.lazy(() => import(/* webpackChunkName: "ISNApplication"*/"../view/MainBoard/ISNApplication/ISNApplication"));
const ISNRequest = React.lazy(() => import(/* webpackChunkName: "ISNRequest"*/"../view/MainBoard/ISNApplication/Request"));
const ISNPreview = React.lazy(() => import(/* webpackChunkName: "ISNPreview"*/"../view/MainBoard/ISNApplication/Preview"));
const ISNBlockPreview = React.lazy(() => import(/* webpackChunkName: "ISNBlockPreview"*/"../view/MainBoard/ISNApplication/BlockPreview"));
const ISNFileUpload = React.lazy(() => import(/* webpackChunkName: "ISNFileUpload"*/"../view/MainBoard/ISNApplication/FileUpload"));
const Edit = React.lazy(() => import(/* webpackChunkName: "Edit"*/"../view/MainBoard/zApplication/Edit"));





//#endregion

const AppRoute = ({ log_session }) => {
    console.log("log_session", log_session)
    return (<React.Suspense fallback={<Loading triggerLoader={true} />}>
        {log_session === 'true' ?
            <Row className="m-0 px-2 py-3">
                <Col className="p-0">
                    <Switch>
                        <Route path="/" exact component={Dashboard} />
                        <Route path="/donorrequest" component={DonorRequest} />
                        <Route path="/setting" component={Setting} />
                        <Route path="/details" component={Details} />

                        <Route path="/ciprequest" component={CIPRequest} />
                        <Route path="/cipApplication/:type" component={CIPApplication} />
                        <Route path="/cipdetails/:id" component={CIPDetails} />
                        <Route path="/cipPreview/:type/:id" component={CIPPreview} />
                        <Route path="/cipsuccess/:type/:id" component={CIPSuccess} />

                        <Route path="/isnrequest" component={ISNRequest} />
                        <Route path="/isnapplication/:type" component={ISNApplication} />
                        <Route path="/ISNApplicationDetails/:type/:id" component={ISNApplicationDetails} />
                        <Route path="/ISNApplicationEdit/:id/:appid" component={ISNApplicationEdit} />
                        <Route path="/ISNPreview/:type/:id" component={ISNPreview} />
                        <Route path="/ISNBlockPreview/:id" component={ISNBlockPreview} />
                        <Route path="/ISNFileUpload/:id" component={ISNFileUpload} />
                        <Route path="/success/:type/:id" component={Success} />

                        <Route path="/depositrequest" component={DepositRequest} />
                        <Route path="/depositapplication/:type" component={DepositApplication} />
                        <Route path="/depositDetails/:id" component={DepositDetails} />
                        <Route path="/depositPreview/:type/:id/:isnid" component={DepositPreview} />
                        <Route path="/depositBlockPreview/:id" component={DepositBlockPreview} />
                        <Route path="/DepositFileUpload/:id" component={DepositFileUpload} />
                        <Route path="/depositsuccess/:type/:id" component={DepositSuccess} />
                        <Route path="/report" component={Report} />

                        <Route path="/edit" component={Edit} />
                        <Route path="/preview" component={Preview} />
                        <Route path="*" exact={true} component={pageError} />
                    </Switch >
                </Col>
            </Row>
            : <Switch>
                <Route path="/" exact component={Main} />
                <Route path="/publiclogin" component={PublicLogin} />
                <Route path="/publishersubuser" component={PublisherSubUser} />
                <Route path="/loginAuthentication" component={LoginAuthentication} />
                <Route path="/registration" component={Registration} />
                <Route path="/retroaccount" component={RetroAccount} />
                <Route path="/singpasslogin" component={SingpassLogin} />
                <Route path="/faq" component={Faq} />

                <Route path="/foreignboard" exact component={ForeignBoard} />
                <Route path="/foreignboard/foreignpreview/:type/:id/:isnid" component={ForeignPreview} />
                <Route path="/foreignboard/foreignsuccess/:type/:id" component={ForeignSuccess} />

                <Route path="*" exact={true} component={pageError} />
            </Switch>}

    </React.Suspense >

    )
}

export default AppRoute;